import { Component, OnInit, Input, Renderer2, ElementRef, HostListener, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

/**
 * ä¾§è¾¹èå
 * 
 * Example of usage:
 * <example-url>https://stackblitz.com/edit/x-button?embed=1&file=src/app/app.component.ts</example-url>
 */
@Component({
  selector: `np-sidenav`,
  templateUrl: 'sidenav.html',
  styleUrls: ['sidenav.scss'],
  encapsulation: ViewEncapsulation.None
})

export class NpSideNav implements OnInit {

  @Input() items: NpSideNavItem[] = [];


  constructor(private renderer2: Renderer2,
    private el: ElementRef,
    private router: Router) {
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {

  }

  ngAfterViewInit() {
  }

  onItemClicked(item: NpSideNavItem) {
    item.expanded = !item.expanded;
    if (item.route) {
      this.router.navigate([item.route]);
    }
  }
}

export interface NpSideNavItem {
  /**å¯ä¸idæ è¯ */
  id: string | number;
  /**èååç§° */
  displayName: string;
  /**èåfa iconï¼ */
  iconName?: string;
  /**èåè·³è½¬è·¯ç± */
  route?: string;
  /**éè¦é«äº®çè·¯ç±æ°ç»ï¼åå«å¨æ­¤æ°ç»ä¸­çè·¯ç±é½ä¼é«äº®å½åroute */
  highlightRoutes?: string[];
  /**å­èåæ°ç» */
  children?: NpSideNavItem[];
  /**æ¯å¦å±å¼å½åèå */
  expanded?: boolean;
}

